import React, { useState, useEffect } from 'react'
import Headers from '../components/Headers'
import Footer from '../components/Footer'
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { RxDashboard } from 'react-icons/rx'
import { RiProductHuntLine } from 'react-icons/ri'
import { BsChat, BsHeart } from 'react-icons/bs'
import { TfiLock } from 'react-icons/tfi'
import { BiLogInCircle } from 'react-icons/bi'
import api from '../api/api'
import { useDispatch } from 'react-redux'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { user_reset } from '../store/reducers/authReducer'
import { reset_count } from '../store/reducers/cardReducer'

const Dashboard = () => {
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const logout = async () => {
        try {
            const { data } = await api.get('/customer/logout')
            localStorage.removeItem('customerToken')
            dispatch(user_reset())
            dispatch(reset_count())
            navigate('/login')
        } catch (error) {
            console.log(error.response.data)
        }
    }

    return (
        <div>
            <div className="">
                <Headers />
            </div>

            <div className='bg-[whitesmoke] md:pb-[30%] md:h-[80vh]'>
                <div className='w-[80%] mx-auto pt-5 md-lg:block hidden'>
                    <div className="flex gap-4 overflow-x-auto whitespace-nowrap">
                        <ul className="flex flex-nowrap">
                            <li className={`flex justify-start items-center gap-1 py-2 text-sm transition-transform duration-300 ${location.pathname === '/dashboard' ? 'text-green-600 bg-green-200 rounded-full px-2' : ''}`}>
                                <span className='text-xl'><RxDashboard /></span>
                                <Link to='/dashboard' className='block'>Dashboard</Link>
                            </li>
                        </ul>

                        <ul className="flex flex-nowrap">
                            <li className={`flex justify-start items-center gap-1 py-2 text-sm transition-transform duration-300 ${location.pathname === '/dashboard/my-orders' ? 'text-purple-600 bg-purple-200 rounded-full px-3 ' : ''}`}>
                                <span className='text-xl'><RiProductHuntLine /></span>
                                <Link to='/dashboard/my-orders' className='block'>My Orders</Link>
                            </li>
                        </ul>

                        <ul className="flex flex-nowrap">
                            <li className={`flex justify-start items-center gap-1 py-2 text-sm transition-transform duration-300 ${location.pathname === '/dashboard/my-wishlist' ? 'text-pink-600  bg-pink-200 rounded-full px-3' : ''}`}>
                                <span className='text-xl'><BsHeart /></span>
                                <Link to='/dashboard/my-wishlist' className='block'>Wishlist</Link>
                            </li>
                        </ul>

                        <ul className="flex flex-nowrap">
                            <li className={`flex justify-start items-center  text-sm gap-1 py-2  transition-transform duration-300 ${location.pathname === '/dashboard/chat' ? 'text-blue-600  bg-blue-200 rounded-full px-3' : ''}`}>
                                <span className='text-xl'><BsChat /></span>
                                <Link to='/dashboard/chat' className='block'>Chat</Link>
                            </li>
                        </ul>

                        <ul className="flex flex-nowrap">
                            <li className={`flex justify-start items-center text-sm gap-1 py-2  transition-transform duration-300 ${location.pathname === '/dashboard/chage-password' ? 'text-yellow-600  bg-yellow-200 rounded-full px-3' : ''}`}>
                                <span className='text-xl'><TfiLock /></span>
                                <Link to='/dashboard/chage-password' className='block'>Password</Link>
                            </li>
                        </ul>

                        <ul className="flex flex-nowrap">
                            <li onClick={logout} className='flex hover:text-red-600 text-sm hover:bg-red-200 rounded-full px-3 transition-transform duration-300 justify-start items-center gap-1 py-2 cursor-pointer'>
                                <span className='text-xl'><BiLogInCircle /></span>
                                <div className='block'>Logout</div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className='h-full mx-auto'>
                    <div className='py-5 flex md-lg:w-[90%]  mx-auto relative'>
                        <div className={` rounded-md z-50 md:hidden w-[270px] ml-4 bg-white`}>
                            <ul className='py-2 text-slate-600 px-4'>
                                <li className={`flex justify-start items-center gap-2 py-2 hover:translate-x-3 transition-transform duration-300 ${location.pathname === '/dashboard' ? 'text-primaryLight' : ''}`}>
                                    <span className='text-xl'><RxDashboard /></span>
                                    <Link to='/dashboard' className='block'>Dashboard</Link>
                                </li>
                                <li className={`flex justify-start items-center gap-2 py-2 hover:translate-x-3 transition-transform duration-300 ${location.pathname === '/dashboard/my-orders' ? 'text-primaryLight' : ''}`}>
                                    <span className='text-xl'><RiProductHuntLine /></span>
                                    <Link to='/dashboard/my-orders' className='block'>My Orders</Link>
                                </li>
                                <li className={`flex justify-start items-center gap-2 py-2 hover:translate-x-3 transition-transform duration-300 ${location.pathname === '/dashboard/my-wishlist' ? 'text-primaryLight' : ''}`}>
                                    <span className='text-xl'><BsHeart /></span>
                                    <Link to='/dashboard/my-wishlist' className='block'>Wishlist</Link>
                                </li>
                                <li className={`flex justify-start items-center gap-2 py-2 hover:translate-x-3 transition-transform duration-300 ${location.pathname === '/dashboard/chat' ? 'text-primaryLight' : ''}`}>
                                    <span className='text-xl'><BsChat /></span>
                                    <Link to='/dashboard/chat' className='block'>Chat</Link>
                                </li>
                                <li className={`flex justify-start items-center gap-2 py-2 hover:translate-x-3 transition-transform duration-300 ${location.pathname === '/dashboard/chage-password' ? 'text-primaryLight' : ''}`}>
                                    <span className='text-xl'><TfiLock /></span>
                                    <Link to='/dashboard/chage-password' className='block'>Change Password</Link>
                                </li>
                                <li onClick={logout} className='flex hover:text-red-500 hover:translate-x-3 transition-transform duration-300 justify-start items-center gap-2 py-2 cursor-pointer'>
                                    <span className='text-xl'><BiLogInCircle /></span>
                                    <div className='block'>Logout</div>
                                </li>
                            </ul>
                        </div>
                        <div className='w-[calc(100%-270px)] md-lg:w-full'>
                            <div className='mx-4 md-lg:mx-0 h-full pb-10'>
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Dashboard